import { FC, useId } from "react";

import { SVG_MUI } from "@ryde/assets";
import { CHECKBOX_DEFAULT_SIZE } from "@ryde/shared";

import { CheckboxControlledMuiContainerStyled } from "./checkboxes.styled";

interface ICheckboxControlledProps {
  checked: boolean;
  width?: number;
  height?: number;
  setCheckedToggle?: () => void;
  e2eData?: string;
  uniqueAttrId?: string;
}

export const CheckboxControlledMui: FC<ICheckboxControlledProps> = ({
  checked,
  setCheckedToggle,
  width = CHECKBOX_DEFAULT_SIZE,
  height = CHECKBOX_DEFAULT_SIZE,
  e2eData = "checkbox-mui-controlled",
  uniqueAttrId,
}) => {
  const generatedId = useId();
  const inputId = uniqueAttrId ?? `checkbox-mui-controlled-${generatedId}`;

  return (
    <CheckboxControlledMuiContainerStyled
      data-e2e-value={checked ? "checked" : "unchecked"}
      data-e2e={e2eData}
      id={inputId}
    >
      {!checked && (
        <SVG_MUI.CheckboxUncheckedSVG
          onClick={setCheckedToggle}
          width={width}
          height={height}
        />
      )}
      {checked && (
        <SVG_MUI.CheckboxCheckedBlueSVG
          onClick={setCheckedToggle}
          width={width}
          height={height}
        />
      )}
    </CheckboxControlledMuiContainerStyled>
  );
};
